import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import BackspaceIcon from '@mui/icons-material/Backspace';
import '../../../Styles/Interface/Conf/NumericKeyPad.css';
import { Tooltip } from '@mui/material';

const NumericKeypad = ({ onKeyClick, onBackspaceClick, isQtyActive, isPriceActive, isDiscountActive, onActiveChangeQty, onActiveChangePrice, onActiveChangeDiscount, disabled, qtyDisabled }) => {
    const keys = [
        [1, 2, 3, "Ctd."],
        [4, 5, 6, "%"],
        [7, 8, 9, "Precio"],
        ['ITBIS','C', 0, '<']
    ];

    const getButtonStyles = (key) => {
        if (key === 'Ctd.' && isQtyActive) {
            return {
                backgroundColor: '#f0f8ee',
                color: '#000',
                border: '1px solid #000'
            };
        } else if (key === '<') {
            return {
                color: '#ff0000',
                backgroundColor: '#ffff'
            };
        } else if (key === 'Precio' && isPriceActive) {
            return {
                backgroundColor: '#f0f8ee',
                color: '#000',
                border: '1px solid #000'
            };
        } else if (key === '%' && isDiscountActive) {
            return {
                backgroundColor: '#f0f8ee',
                color: '#000',
                border: '1px solid #000'
            };
        } else {
            return {
                backgroundColor: '#ffff',
                color: '#000'
            };
        }
    };

    return (
        <Grid container spacing={0.5} justifyContent="center">
            {keys.flat().map((key) => (
                <Grid item key={key} xs={3}>
                    {isNaN(key) ? (
                        <Tooltip title={`${key === 'Ctd.' ? "Modificar cantidad" : ''} ${key === '%' ? 'Aplicar descuento' : ''} 
                        ${key === 'Precio' ? 'Modificar precio' : ''} ${key === '<' ? 'Borrar valor' : ''} ${key === 'C' ? 'Limpiar campo' : ''} 
                        ${key === 'ITBIS' ? 'Impuestos' : ''}`} placement="right">
                            <Button
                                variant="contained"
                                onClick={() => {
                                    if (key === '<') {
                                        onBackspaceClick();
                                    } else if (key === 'C') {
                                        onClearClick();
                                    } else if (key === 'Ctd.') {
                                        onActiveChangeQty();
                                    } else if (key === 'Precio') {
                                        onActiveChangePrice();
                                    } else if (key === '%') {
                                        onActiveChangeDiscount();
                                    } else {
                                        onKeyClick(key);
                                    }
                                }}
                                fullWidth
                                sx={{
                                    ...getButtonStyles(key),
                                    '&:hover': {
                                        backgroundColor: key === 'Ctd.' ? '#f0f8ee' : '#f0f0f0',
                                        color: '#000'
                                    }
                                }}
                                disabled={key === 'ITBIS'}
                            >
                                {key === '<' ? <BackspaceIcon /> : key}
                            </Button>
                        </Tooltip>
                    ) : (
                        <Button
                            variant="contained"
                            onClick={() => onKeyClick(key)}
                            fullWidth
                            sx={{
                                ...getButtonStyles(key),
                                '&:hover': {
                                    backgroundColor: '#f0f0f0',
                                    color: '#000'
                                }
                            }}
                        >
                            {key}
                        </Button>
                    )}
                </Grid>
            ))}
        </Grid>
    );
};

export default NumericKeypad;
